import Vue from "vue";
import VueRouter from "vue-router";
import Index from "./components/index/index";
import News from "./components/index/news";
import NewsDetail from "./components/index/newsDetail";
import Aboutus from "./components/index/aboutus";
import Newproduct from "./components/index/newproduct";
import Download from "./components/index/download";
import Filter from "./components/index/filter";
import Classify from "./components/index/classify";
import Detail from "./components/index/detail";

Vue.use(VueRouter);

const routes = [
  { path: "", redirect: "/index" },
  { path: "/index", component: Index, meta: { name: 1 } },
  { path: "/news", component: News, meta: { name: 2 } },
  {
    path: "/newsDetail",
    component: NewsDetail,
  },
  { path: "/aboutus", component: Aboutus, meta: { name: 3 } },
  { path: "/newproduct", component: Newproduct, meta: { name: 4 } },
  { path: "/download", component: Download, meta: { name: 5 } },
  { path: "/filter", component: Filter },
  { path: "/classify", component: Classify },
  {
    path: "/detail",
    name: "detail",
    component: Detail,
  },
];

export default new VueRouter({ routes });
